import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";

const Columns = ({ handleViewHandler, handleCancelHandler }) => [
  {
    dataField: "scheduleId",
    text: "Schedule ID",
    formatter: (_, row) => <span>{row?.scheduleId || "--"}</span>,
  },
  {
    dataField: "type",
    text: "Type",
    formatter: (_, row) => (
      <span>{row?.type || "Info"}</span>
    ),
  },
  {
    dataField: "status",
    text: "Status",
    formatter: (_, row) => (
      <span>{row?.status || "--"}</span>
    ),
  },
  {
    dataField: "description",
    text: "Description",
    formatter: (_, row) => (
      <span className="text-wrap" style={{ maxWidth: "250px", display: "inline-block" }}>
        {row?.description || "--"}
      </span>
    ),
  },
  {
    dataField: "scheduledTime",
    text: "Schedule Slot",
    formatter: (_, row) => {
      if (!row?.scheduledTime?.length) {
        return <span>--</span>;
      }

      return (
        <div className="d-flex align-items-center gap-2 flex-wrap">
          {row.scheduledTime.map((slot, index) => {
            const status = slot?.scheduledStatus?.toLowerCase();

            let bgColor = "#e9ecef";
            let color = "#6c757d";
            let icon = "";

            if (status === "sent") {
              bgColor = "#198754";
              color = "#fff";
              icon = "✓";
            } else if (status === "cancelled") {
              bgColor = "#dc3545";
              color = "#fff";
              icon = "✕";
            } else if (status === "pending") {
              bgColor = "#dee2e6";
              color = "#adb5bd";
              icon = "";
            }

            return (
              <div
                key={index}
                title={`Slot ${index + 1} - ${slot?.scheduledStatus}`}
                style={{
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  backgroundColor: bgColor,
                  color,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "13px",
                  fontWeight: "bold",
                  border: "1px solid #ced4da",
                }}
              >
                {icon}
              </div>
            );
          })}
        </div>
      );
    },
  },
  {
    dataField: "date_created_utc",
    text: "Created At",
    formatter: (_, row) => (
      <span>{row?.date_created_utc ? DATE_FORMAT(row.date_created_utc) : "--"}</span>
    ),
  },
  {
    text: "Action",
    dataField: "action",
    formatter: (_, row) => (
      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        {/* View */}
        <button
          className="fas fa-eye"
          title="View"
          style={{
            fontSize: "16px",
            backgroundColor: "#fff",
            border: "none",
            cursor: "pointer",
          }}
          onClick={() => handleViewHandler(row)}
        />

        {/* Cancel */}
        {row?.status === "Active" && (
          <button
            className="fas fa-ban"
            title="Cancel"
            style={{
              fontSize: "16px",
              backgroundColor: "#fff",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => handleCancelHandler(row)}
          />
        )}
      </div>
    ),
  },
];

export default Columns;
